// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3df8aaae] .van-notice-bar {\n  background: transparent;\n}\n[data-v-3df8aaae] .van-notice-bar .van-swipe-item {\n  text-align: center;\n  overflow: hidden;\n  font-size: 0.32rem;\n}\n.buyer-show[data-v-3df8aaae] {\n  margin: 0 auto 0.32rem;\n}\n.buyer-show .notice-swipe[data-v-3df8aaae] {\n  height: 0.48rem;\n  font-size: 0.34667rem;\n  font-weight: 500;\n  color: #d4b37d;\n  line-height: 0.48rem;\n}", ""]);
// Exports
module.exports = exports;
